<template>
  <el-form class="subject">
    <el-form-item label="题目类型:">
      <el-select
          class="w400"
          :disabled="!!subjectInfo.id"
          v-model="subjectInfo.type">
        <el-option
            v-for="item in getSubjectTypeOptions"
            :key="item.metaCode"
            :label="item.metaName"
            :value="item.metaCode">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="类型别名:" v-if="openAlias">
      <el-input
          class="w400"
          v-model="subjectInfo.typeAlias">
      </el-input>
    </el-form-item>
    <el-form-item label="得分类型:">
      <el-select
          class="w400"
          placeholder="得分类型"
          :disabled="!!subjectInfo.id"
          v-model="subjectInfo.scoreType">
        <el-option
            v-for="item in getScoreTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="题目分数:">
      <el-input-number
          class="w400"
          :disabled="subjectInfo.type === 'case' || subjectInfo.scoreType === 2"
          :precision="2"
          :step="0.01"
          :min="0.01"
          placeholder="题目分数"
          v-model="subjectInfo.score">
      </el-input-number>
    </el-form-item>
    <el-form-item label="题目维度:">
      <div
          style="display: inline-block;"
          v-if="subjectInfo.scoreType === 2 || subjectInfo.type === 'case'">
        <template v-if="subjectInfo.type === 'subjective'">
          {{getWd([subjectiveContentWd1, subjectiveContentWd2].join(','))}}
        </template>
        <template v-else>
          {{getWd(subjectInfo.wdcodes)}}
        </template>
      </div>
      <el-select
          class="w400"
          v-else
          placeholder="题目维度"
          v-model="subjectInfo.wdcodes"
          filterable
      >
        <el-option
            v-for="item in wdList"
            :key="item.wdcode"
            :label="item.wdname"
            :value="item.wdcode">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="题目难度:" v-if="mode !== 'child'">
      <el-select
          class="w400"
          placeholder="题目难度"
          v-model="subjectInfo.difficulty">
        <el-option label="易" :value="1"></el-option>
        <el-option label="中" :value="2"></el-option>
        <el-option label="难" :value="3"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="题目标签:" v-if="mode !== 'child'">
      <div>
        <el-tag
            :key="tag"
            v-for="(tag, index) in subjectInfo.tags"
            :type="['', 'success', 'info', 'warning', 'danger'][(index + 5) % 5]"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
      </div>
    </el-form-item>
    <el-form-item label="题干内容:">
      <div style="display: inline-block;line-height: normal;">
        <editor v-model="subjectInfo.title"></editor>
      </div>
    </el-form-item>
    <el-form-item label=" ">
      <div class="display-flex align-items-center">
        <span v-if="!subjectInfo.files" style="cursor: pointer;color: #409EFF;" @click="addAVFile">为题干添加音视频文件</span>
        <video v-if="subjectInfo.files && subjectInfo.mediaType === 'video'" :src="getSrc" controls controlslist="nodownload" width="300"/>
        <audio v-if="subjectInfo.files && subjectInfo.mediaType === 'audio'" :src="getSrc" controls controlslist="nodownload"/>
        <span v-if="subjectInfo.files" class="ml10 cursor-pointer" style="color: #409EFF;" @click="delFile">删除文件</span>
      </div>
    </el-form-item>
    <!--客观题 常规得分-->
    <template v-if="objectivesList.includes(subjectInfo.type) && subjectInfo.scoreType === 1">
      <el-checkbox-group v-model="checkedUuids">
        <el-row
            style="margin-top: 1rem;font-size: 14px" v-for="(item, index) in subjectInfo.options" :key="index" :gutter="10">
          <el-col :span="3" style="margin-top: 1%">
            <span>选项内容:</span>
          </el-col>
          <el-col :span="19">
            <el-input placeholder="选项内容" v-model="item.content">
              <template slot="append">
                <el-checkbox :label="item.uuid" :key="item.uuid">正确答案
                </el-checkbox>
              </template>
            </el-input>
          </el-col>
          <el-col :span="2" style="margin-top: 1%">
            <span
                style="cursor: pointer;color: #409EFF;"
                @click="delOption(index)"
            >删除</span>
          </el-col>
        </el-row>
      </el-checkbox-group>
    </template>
    <!--客观题 选项得分-->
    <template v-if="objectivesList.includes(subjectInfo.type) && subjectInfo.scoreType === 2">
      <el-row
          style="margin-top: 1rem" v-for="(item, index) in subjectInfo.options" :gutter="10">
        <el-col :span="3" style="margin-top: 1%;">
          <span>选项内容:</span>
        </el-col>
        <el-col :span="19">
          <el-row>
            <el-input placeholder="选项内容" v-model="item.content">
            </el-input>
          </el-row>
          <el-row>
            <el-row v-for="(i,idx) in item.scores" :key="idx" style="margin-top: 10px">
              <el-select placeholder="选项维度" v-model="i.wdcode">
                <el-option
                    v-for="wd in wdList"
                    :key="wd.wdcode"
                    :label="wd.wdname"
                    :value="wd.wdcode">
                </el-option>
              </el-select>
              <el-input-number
                  placeholder="选项分数"
                  :precision="2"
                  :step="0.01"
                  :min="0"
                  v-model="i.score" style="margin-left: 10px">
              </el-input-number>
              <span style="cursor: pointer;color: #409EFF;margin-left: 10px"
                    @click="delWdScore(index,idx)">删除</span>
            </el-row>
          </el-row>
          <el-row style="margin-top: 10px">
            <span style="cursor: pointer;color: #409EFF;" @click="addWdScore(index)">
              添加维度分数
            </span>
          </el-row>
        </el-col>
        <el-col :span="2" style="margin-top: 1%">
          <span style="cursor: pointer;color: #409EFF;" @click="delOption(index)">删除</span>
        </el-col>
      </el-row>
    </template>


    <!-- 案例题     -->
    <template v-if="subjectInfo.type === 'case'">
      <el-row class="mt16"
              v-for="(item,index) in subjectInfo.children">
        <el-card>
          <div class="display-flex align-items-center h40" style="font-size: 16px;font-weight: 600;">
            <span>子试题{{ index + 1 }}</span>
            <el-tooltip
                class="item"
                effect="dark"
                content="上移"
                placement="right"
            >
              <i class="el-icon-top" v-if="index > 0" @click="moveUp(index)"/>
            </el-tooltip>
          </div>

          <subject
              :key="`subject-child-${index}`"
              ref="subSubject"
              :subjectTypeOptions="subjectTypeOptions"
              :wdList="wdList"
              mode="child"
              :subject.sync="subjectInfo.children[index]"/>
          <span style="cursor: pointer;color: #409EFF;" @click="delSubTitle(index)">删除子题干</span>
        </el-card>
      </el-row>
    </template>

    <!--     迫选题      -->
    <el-row
        v-if="subjectInfo.type === 'subjective'"
        style="margin-top: 1rem"
        :gutter="10">
      <el-col :span="3" style="margin-top: 1%">
        <span>选项配置:</span>
      </el-col>
      <el-col :span="19">
        <div class="display-flex align-items-center">
          <el-input placeholder="选项1" v-model="subjectiveContent1">
          </el-input>
          <el-select class="ml10" placeholder="维度" v-model="subjectiveContentWd1">
            <el-option
                v-for="wd in wdList"
                :key="wd.wdcode"
                :label="wd.wdname"
                :value="wd.wdcode">
            </el-option>
          </el-select>
        </div>
        <div class="mt20 display-flex align-items-center">
          <el-input placeholder="选项2" v-model="subjectiveContent2">
          </el-input>
          <el-select class="ml10" placeholder="维度" v-model="subjectiveContentWd2">
            <el-option
                v-for="wd in wdList"
                :key="wd.wdcode"
                :label="wd.wdname"
                :value="wd.wdcode">
            </el-option>
          </el-select>
        </div>
        <div class="mt20 display-flex align-items-center">
          <div>
            最小分数：
          </div>
          <div>
            <el-input-number
                :step="1"
                :min="0"
                placeholder="最小分数"
                :controls="false"
                v-model="minStep"></el-input-number>
          </div>
          <div class="ml10">
            最大分数：
          </div>
          <div>
            <el-input-number
                :step="1"
                :min="minStep + 1"
                placeholder="最大分数"
                :controls="false"
                v-model="maxStep"></el-input-number>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row
        v-if="['fill_in_the_blanks', 'short_answer', 'upload'].includes(subjectInfo.type)"
        style="margin-top: 1rem"
        :gutter="10">
      <el-col :span="3" style="margin-top: 1%">
        <span>题目解析:</span>
      </el-col>
      <el-col :span="19">
        <el-input placeholder="题目解析内容" v-model="subjectInfo.answer">
        </el-input>
      </el-col>
    </el-row>
    <el-row style="margin-top: 25px">
      <!--                  <el-col :span="2"></el-col>-->
      <el-col :span="22">
        <span v-if="objectivesList.includes(subjectInfo.type) && subjectInfo.scoreType" style="cursor: pointer;color: #409EFF;"
              @click="addOption">
          添加选项
        </span>
        <span v-if="subjectInfo.type === 'case'" style="cursor: pointer;color: #409EFF;" @click="addChildren">
          添加子题干
        </span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 3rem;" :gutter="20" v-if="mode !== 'child'">
      <el-col :span="12" style="text-align: left" v-if="showCancel">
        <el-button @click="cancelSave">取消</el-button>
      </el-col>
      <el-col :span="12" style="text-align: right">
        <el-button @click="verify">保存</el-button>
      </el-col>
    </el-row>
    <el-upload id="uploadFile" action="" :headers="uploadHeader"
               :show-file-list="false" :http-request="upload"></el-upload>
  </el-form>
</template>
<script>
import editor from "@/components/tinymceEditor/editor.vue";
import {getAdminId, getToken} from "@/utils/auth";

export default {
  name: "subject",
  components: {
    editor,
  },
  props: {
    subjectTypeOptions: {
      type: Array,
      default: () => []
    },
    wdList: {
      type: Array,
      default: () => []
    },
    subject: {
      type: Object,
      default: () => ({})
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: ''
    },
    openAlias: {
      type: Boolean,
      default: false
    },
    scoreType: {
      type: Number
    }
  },
  data() {
    return {
      subjectInfo: {
        id: '',
        score: null,
        title: '',//题干
        type: '',//题目分类：single_choice.单选，multiple_choice.多选....
        typeAlias: '',//分类别名
        scoreType: null,//得分类型：1.常规得分，2.选项得分
        mediaType: null,//资料上传类型：audio.音频，video.视频
        files: null,
        wdcodes: '',//维度：逗号分隔
        tags: [],//标签：逗号分隔
        options: [],
        children: [] //案例题子题干
      },
      myUploadPath: "id-photo-pending",
      scoreTypeOptions: [{label: '常规得分', value: 1}, {label: '选项得分', value: 2}],
      objectivesList: ['single_choice', 'multiple_choice', 'true_false'],
      checkedUuids: [],
      inputVisible: false,
      inputValue: '',
      subjectiveContent1: '',
      subjectiveContent2: '',
      subjectiveContentWd1: '',
      subjectiveContentWd2: '',
      minStep: 0,
      maxStep: 1,
    }
  },
  computed: {
    uploadHeader: function () {
      return {
        Authorization: getToken(),
        Authorizator: getAdminId()
      };
    },
    getSubjectTypeOptions() {
      if (this.mode === 'child') {
        return this.subjectTypeOptions.filter(v => v.metaCode !== 'case')
      }
      return this.subjectTypeOptions
    },
    getScoreTypeOptions() {
      if (this.scoreType) {
        return this.scoreTypeOptions.filter(v => v.value === this.scoreType)
      }
      let scoreTypeOptions = this.scoreTypeOptions;
      if (['fill_in_the_blanks', 'case', 'short_answer', 'upload'].includes(this.subjectInfo.type)) {
        scoreTypeOptions = scoreTypeOptions.filter(v => v.value === 1)
      }
      if (['subjective'].includes(this.subjectInfo.type)) {
        scoreTypeOptions = scoreTypeOptions.filter(v => v.value === 2)
      }
      return scoreTypeOptions
    },
    getWd() {
      return (wdcodes) => {
        if (!wdcodes) {
          return ''
        }
        let wdcodeList = wdcodes.split(',')
        return wdcodeList.map(item => {
          let wd = this.wdList.find(v => v.wdcode === item)
          if (wd) {
            return wd.wdname
          }
          return item
        }).join('，')
      }
    },
  },
  asyncComputed: {
    async getSrc () {
      if (this.subjectInfo.files) {
        return await this.signatureUrl(this.subjectInfo.files.name)
      }
    }
  },
  watch: {
    subject: {
      handler(val) {
        if (val && val.id) {
          this.subjectInfo = {
            ...this.subjectInfo,
            ...JSON.parse(JSON.stringify(val))
          }
          if (val.tags && this.mode !== 'child') {
            this.subjectInfo.tags = val.tags.split(',')
          } else {
            this.subjectInfo.tags = []
          }
          if (val.files) {
            this.subjectInfo.files = JSON.parse(val.files)
          }
          if (this.subjectInfo.scoreType === 1 && this.subjectInfo.options) {
            this.checkedUuids = []
            this.subjectInfo.options.forEach(item => {
              item.uuid = this.guid()
              if (item.correct) {
                this.checkedUuids.push(item.uuid)
              }
            })
          }
          if (this.subjectInfo.type === 'subjective') {
            this.subjectiveContent1 = this.subjectInfo.options.find(v => v.groupNum === 1).content
            this.subjectiveContent2 = this.subjectInfo.options.find(v => v.groupNum === 2).content
            this.subjectiveContentWd1 = this.subjectInfo.options.find(v => v.groupNum === 1).scores[0].wdcode
            this.subjectiveContentWd2 = this.subjectInfo.options.find(v => v.groupNum === 2).scores[0].wdcode
            this.minStep = Math.min(...this.subjectInfo.options.map(v => v.scores[0].score))
            this.maxStep = Math.max(...this.subjectInfo.options.map(v => v.scores[0].score))
          }
        }
      },
      immediate: true
    },
    checkedUuids(val) {
      if (this.subjectInfo.type !== 'multiple_choice' && this.checkedUuids.length > 1) {
        this.checkedUuids = [this.checkedUuids[this.checkedUuids.length - 1]]
      }
      this.subjectInfo.options.forEach((v) => {
        v.correct = this.checkedUuids.includes(v.uuid);
      })
    },
    'subjectInfo.wdcodes'(newVal, oldVal) {
      if (this.mode === 'child') {
        this.sendToParent()
      }
    },
    'subjectInfo.options': {
      handler(newVal, oldVal) {
        if (this.subjectInfo.scoreType === 2) {
          let wdCodeStr = []
          newVal.forEach(item => {
            let scoresList = item.scores
            if (scoresList && scoresList.length > 0) {
              scoresList.forEach(s => {
                if (s.wdcode) {
                  wdCodeStr.push(s.wdcode)
                }
              })
            }
          })
          if (wdCodeStr.length > 0) {
            this.subjectInfo.wdcodes = Array.from(new Set(wdCodeStr)).join(',')
          }
        } else if (this.subjectInfo.scoreType === 1) {
          let ids = []
          for (let i = 0; i < this.checkedUuids.length; i++) {
            if(!newVal.some(item => item.uuid === this.checkedUuids[i])) {
              ids.push(this.checkedUuids[i])
            }
          }
          this.checkedUuids = this.checkedUuids.filter(v => !ids.includes(v))
        }
      },
      deep: true
    },
    'subjectInfo.children': {
      handler(newVal, oldVal) {
        if (this.subjectInfo.type === 'case') {
          let wdCodeStr = []
          if (newVal && newVal.length) {
            this.subjectInfo.wdcodes = Array.from(new Set(newVal.map(v => v.wdcodes))).join(',')
          } else {
            this.subjectInfo.wdcodes = ''
          }
        }
      },
      deep: true
    },
    'subjectInfo.type'(val) {//题目类型监听
      if (!this.subjectInfo.id) {//新增时
        if (val === 'case') {//案例题初始化children
          this.subjectInfo.scoreType = 1  //案例题得分类型默认为常规得分
          this.subjectInfo.children = [{
            score: null,
            title: '',//题干
            type: '',//题目分类：single_choice.单选，multiple_choice.多选....
            typeAlias: '',//分类别名
            scoreType: null,//得分类型：1.常规得分，2.选项得分
            mediaType: null,//资料上传类型：audio.音频，video.视频
            files: null,
            wdcodes: '',//维度：逗号分隔
            options: [],
          }]
        } else if (val === 'true_false') {
          if (this.subjectInfo.options.length > 2) {
            this.subjectInfo.options = this.subjectInfo.options.slice(0, 2)
          }
        } else if (val === 'subjective') {
          this.subjectInfo.scoreType = 2  //主观题得分类型默认为选项得分
        } else if (['fill_in_the_blanks', 'short_answer', 'upload'].includes(val)) {
          this.subjectInfo.scoreType = 1  //填空、简答、资料上传题得分类型默认为常规得分
        }
      }
    },
    'subjectInfo.scoreType'(val) {//得分类型监听
      if (!this.subjectInfo.id) {//新增时
        if (val === 2) {//选项得分
          this.subjectInfo.score = null //题目分数置空
          this.subjectInfo.wdcodes = null //题目维度置空
        }
      }
    },
  },
  methods: {
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    addAVFile() {
      document.querySelector('#uploadFile input').click()
    },
    upload(data) {
      let that = this;
      let fileType = data.file.type
      if (!fileType.startsWith('video') && !fileType.startsWith('audio')) {
        that.$message({
          message: "只能上传音视频文件",
          type: "error"
        });
        return
      }
      that.subjectInfo.mediaType = fileType
      // 先要获取后端签名
      that.loadingInstance = that.$loading({lock: true, text: "拼命上传中"});
      let fileName = that.random_string(6) + "_" + new Date().getTime() + "." + data.file.name.split(".").pop();
      that.multipartUpload(that.myUploadPath + "/" + fileName, data.file, {
        headers: {'Content-Type': fileType}
      }).then(results => {
        // 上传完成 image/jpeg video/mp4  audio/mpeg
        that.loadingInstance.close();
        if (results.res.statusCode === 200) {
          that.$message({
            message: "上传成功",
            type: "success"
          });
          that.subjectInfo.files = {'name': results.name}
          if (fileType.startsWith('video')) {
            that.subjectInfo.mediaType = 'video'
          } else if (fileType.startsWith('audio')) {
            that.subjectInfo.mediaType = 'audio'
          }
        }
      }).catch(err => {
        that.loadingInstance.close();
        that.$message.error("上传失败，请重新上传");
      });
    },
    random_string(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    delFile() {
      this.subjectInfo.files = null
    },
    delOption(index) {
      if ((this.subjectInfo.options.length > 2 && this.objectivesList.includes(this.subjectInfo.type))  //客观题
          || (this.subjectInfo.options.length > 1 && !this.objectivesList.includes(this.subjectInfo.type))) {//主观题
        this.subjectInfo.options.splice(index, 1);
      } else {
        this.$message.error("客观题型至少有两个选项, 主观题型至少有一个子项");
      }
    },
    delWdScore(index, idx) {
      this.subjectInfo.options[index].scores.splice(idx, 1);
    },
    addWdScore(index) {
      if (!this.subjectInfo.options[index].scores) {
        this.subjectInfo.options[index].scores = [{}]
      } else {
        this.subjectInfo.options[index].scores.push({
          score: '',
          wdcode: ''
        })
      }
    },
    delSubTitle(index) {
      this.subjectInfo.children.splice(index, 1);
    },
    addOption() {
      if (this.subjectInfo.type === 'true_false' && this.subjectInfo.options.length >= 2) {//判断题
        this.$message.error("该题型只能有两个选项");
        return false;
      } else if (this.subjectInfo.type === 'fill_in_the_blanks' || this.subjectInfo.type === 'short_answer') {//填空、简答
        this.$message.error("该题型只能有一个子项");
        return false;
      } else {
        if (this.subjectInfo.options.length > 0 && !this.subjectInfo.options[this.subjectInfo.options.length - 1].content) {
          this.$message.error("请完善上一条信息后再添加");
        } else {
          this.subjectInfo.options.push({
            uuid: this.guid(),
            content: '',
            scores: [],
            correct: ''
          })
        }
      }
    },
    addChildren() {
      this.subjectInfo.children.push({
        score: null,
        title: '',//题干
        type: '',//题目分类：single_choice.单选，multiple_choice.多选....
        typeAlias: '',//分类别名
        scoreType: null,//得分类型：1.常规得分，2.选项得分
        mediaType: null,//资料上传类型：audio.音频，video.视频
        files: null,
        wdcodes: '',//维度：逗号分隔
        options: [],
      })
    },
    moveUp(index) {
      this.subjectInfo.children.splice(index - 1, 1, ...this.subjectInfo.children.splice(index, 1, this.subjectInfo.children[index - 1]))
    },
    handleClose(tag) {
      this.subjectInfo.tags.splice(this.subjectInfo.tags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.subjectInfo.tags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    cancelSave() {
      this.$emit('cancel')
    },
    verify() {
      if (!this.subjectInfo.type) {
        this.$message.error("题目类型不能为空");
        return false;
      }
      if (this.subjectInfo.scoreType === 1) {//题目得分
        if (!this.subjectInfo.score) {
          this.$message.error("题目分数不能为空");
          return false;
        }
        if (!this.subjectInfo.wdcodes) {
          this.$message.error("维度不能为空");
          return false;
        }
      }
      if (!this.subjectInfo.title) {
        this.$message.error("题干内容不能为空");
        return false;
      }
      if (this.objectivesList.includes(this.subjectInfo.type) && this.subjectInfo.options.length < 2) {
        this.$message.error("客观题选项不能少于两个");
        return false;
      }
      if (this.objectivesList.includes(this.subjectInfo.type) && this.subjectInfo.scoreType === 1) {//客观题 题目得分
        let rightOptionCount = 0;
        this.subjectInfo.options.forEach(item => {
          if (item.correct) {
            rightOptionCount++;
          }
        });
        if (rightOptionCount === 0) {
          this.$message.error("客观题必须有一个正确选项");
          return false;
        }
      }
      if (this.objectivesList.includes(this.subjectInfo.type)) {//客观题
        for (let i = 0; i < this.subjectInfo.options.length; i++) {
          let option = this.subjectInfo.options[i]
          let content = option.content
          if (!content) {
            this.$message.error("选项内容不能为空");
            return false
          }
          let scores = option.scores
          if (this.subjectInfo.scoreType === 2) {//选项得分
            for (let j = 0; j < scores.length; j++) {
              let score = scores[j]
              if (!score.wdcode) {
                this.$message.error("选项维度不能为空");
                return false
              }
            }
          }
        }
      }
      if (this.subjectInfo.type === 'case') {//案例题
        if (this.subjectInfo.children.length < 1) {
          this.$message.error("案例题必须有子题干")
          return false
        }
        if (this.$refs.subSubject.length > 0) {
          for (let i = 0; i < this.$refs.subSubject.length; i++) {
            let res = this.$refs.subSubject[i].verify()
            if (res !== undefined) {
              return false
            }
          }
        }
      }
      if (this.mode === 'child') {
        this.sendToParent()
      } else {
        this.saveSubject();
      }

    },
    getFormData() {
      let subjectInfo = JSON.parse(JSON.stringify(this.subjectInfo))
      if (subjectInfo.files) {
        subjectInfo.files = JSON.stringify(subjectInfo.files)
      }
      if (subjectInfo.options) {
        subjectInfo.options.forEach(item => {
          delete item.uuid
        })
      }
      if (!this.openAlias) {
        delete subjectInfo.typeAlias
      }
      if (subjectInfo.type === 'subjective') {
        let options = []
        for (let i = this.minStep; i <= this.maxStep; i++) {
          options.push({
            content: this.subjectiveContent1,
            groupNum: 1,
            scores: [{
              score: i,
              wdcode: this.subjectiveContentWd1
            }]
          })
          options.push({
            content: this.subjectiveContent2,
            groupNum: 2,
            scores: [{
              score: this.maxStep - i,
              wdcode: this.subjectiveContentWd1
            }]
          })
        }
        options = options.sort(function(a, b) {
          if (a.groupNum === b.groupNum) {
            return a.scores[0].score - b.scores[0].score;
          }
          return a.groupNum - b.groupNum;
        })
        subjectInfo.options = options
      }
      return subjectInfo
    },
    sendToParent() {
      let subjectInfo = this.getFormData()
      subjectInfo.tags = null
      this.$emit('update:subject', subjectInfo)
    },
    saveSubject() {
      let subjectInfo = this.getFormData()
      if (subjectInfo.tags) {
        subjectInfo.tags = subjectInfo.tags.join(',')
      }
      this.$emit('confirm', subjectInfo)
    },
  }
}
</script>
<style lang="scss" scoped>
.subject {
  .el-icon-top {
    color: #E93C27;
    font-size: 20px;
    margin-left: 10px;
    cursor: pointer;
  }
  .el-tag {
    margin-right: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
  }
}
</style>
